import { ReportType } from './reports-table-row';

type GetReportTypeDetailsPayload = {
  type: ReportType;
};

export const getReportTypeDetails = ({ type }: GetReportTypeDetailsPayload) => {
  switch (type) {
    case 'master-cleaning-schedule': {
      return {
        reportName: 'master cleaning schedule report',
        fileNamePrefix: 'master cleaning schedule report',
      };
    }

    case 'service-zone': {
      return {
        reportName: 'service zone report',
        fileNamePrefix: 'service zone report',
      };
    }

    case 'target-zone': {
      return {
        reportName: 'target zone report',
        fileNamePrefix: 'target zone report',
      };
    }

    case 'zone-setup': {
      return {
        reportName: 'zone setup report',
        fileNamePrefix: 'zone setup report',
      };
    }

    default: {
      return {};
    }
  }
};
